<div class="metrics-hint">
  <b>Create your own Metrics:</b>
  <ul>
    <li>&ndash; Track your progress</li>
    <li>&ndash; Automatic <span class="highlight">Cost Per Outcome</span> calculation</li>
    <li>&ndash; Review your <span class="highlight">ROI</span> at all times</li>
  </ul>
</div>
